export default "__VITE_ASSET__7b57c00f__"